import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface FieldsetProps {
  className?:string;
  title?: ReactNode;
  color?: string;
  titleSize?: string;
  borderColor?: string;
  borderWidth?: number;
  borderRadius?: number;
  width?:string;
  children: ReactNode;
  sx?: SxProps<Theme>;

}
export const Fieldset = ({
  title,
  color = "rgba(0, 0, 0, 0.6)",
  titleSize = "1rem",
  borderColor = "inital",
  borderWidth = 1,
  borderRadius = 2,
  width ='50%',
  children,
  sx = {},
  ...props
}: FieldsetProps) => {
  return (
    <Box
      component="fieldset"
      sx={{
        borderColor: borderColor,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        width: width,
        ...sx,
      }}
      {...props}
    >
      {title && (
        <Typography
          component="legend"
          sx={{
            color: color,
            fontSize: titleSize,
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};